import { useModalState } from '@bechtel/gds';
import { FilterGroupInput } from '@bechtel/sr-types';
import { ICellRendererParams, IRowNode } from 'ag-grid-enterprise';
import { PropsWithChildren } from 'react';
import { PickListButton } from '~/components';
import { FilterModal, getFilterString } from '../../filter-modal';
import { CellContainerStyled } from './styled';

interface ComplexFilterProps {
  getEntityName: (node: IRowNode) => string;
  onRowEdited: (data: any) => void;
}

export const ComplexFilterCellRenderer = (props: PropsWithChildren<ComplexFilterProps & ICellRendererParams>) => {
  const { onRowEdited, value, children, colDef, node, getEntityName } = props;
  const filterGroup: FilterGroupInput = value ? JSON.parse(value) : {};
  const cellValue = getFilterString(filterGroup);
  const { visible, open, close } = useModalState(false);

  return (
    <>
      <CellContainerStyled>
        {children ? children : cellValue}

        <PickListButton
          onClick={() => {
            open();
          }}
        ></PickListButton>
      </CellContainerStyled>
      {visible && getEntityName && (
        <FilterModal
          close={close}
          visible={visible}
          entityName={getEntityName(node)}
          initialFilter={filterGroup}
          onApplyFilter={(value) => {
            if (colDef?.field) onRowEdited({ ...node.data, [colDef?.field]: JSON.stringify(value) });
          }}
        />
      )}
    </>
  );
};
